<section class="watch-page-shell">
    <mat-drawer-container class="watch-flyout-container" [hasBackdrop]="isProjectFlyoutOpen"
        (backdropClick)="closeProjectFlyout()">
        <mat-drawer class="watch-project-flyout" position="end" mode="over" [opened]="isProjectFlyoutOpen"
            (closedStart)="onFlyoutClosed()">
            <app-project-display *ngIf="flyoutProject$ && flyoutProjectId !== null" [@fadeSlide]
                [project$]="flyoutProject$" [projectId]="flyoutProjectId"></app-project-display>
        </mat-drawer>

        <mat-drawer-content class="watch-flyout-content">
            <div class="mb-3">
                <div *ngIf="watch" class="panel panel-default watch-details-panel mb-2">
                    <div class="panel-body">
                        <div class="watch-main">
                            <div class="watch-name">{{ watch.name }}</div>
                            <div class="watch-description" *ngIf="watch.description">{{ watch.description }}</div>
                        </div>

                        <div class="watch-metadata">
                            <div class="watch-meta-item watch-meta-item-enabled watch-meta-item-fixed">
                                <div class="watch-meta-label">Enabled</div>
                                <div class="watch-meta-value">
                                    <mat-checkbox [(ngModel)]="watch.isEnabled"
                                        (change)="onEnableChanged()"></mat-checkbox>
                                </div>
                            </div>

                            <div class="watch-meta-item">
                                <div class="watch-meta-label">Frequency</div>
                                <div class="watch-meta-value">{{ watch.notificationFrequency }}</div>
                            </div>

                            <div class="watch-meta-item">
                                <div class="watch-meta-label">Last Notified</div>
                                <div class="watch-meta-value">{{ watch.lastNotified ? (watch.lastNotified | date: 'd MMM
                                    yyyy')
                                    : 'never' }}</div>
                            </div>

                            <div class="watch-meta-item">
                                <div class="watch-meta-label">Next Due</div>
                                <div class="watch-meta-value">{{ watch.nextNotification ? (watch.nextNotification |
                                    date: 'd MMM
                                    yyyy') : 'never' }}</div>
                            </div>

                            <div class="watch-meta-item">
                                <div class="watch-meta-label">Created</div>
                                <div class="watch-meta-value">{{ watch.created | date: 'd MMM yyyy' }}</div>
                            </div>

                            <div class="watch-meta-item watch-meta-item-fixed updated-since-badge"
                                *ngIf="highlightSinceDate">
                                <div class="watch-meta-label">Updated Since</div>
                                <div class="watch-meta-value">{{ highlightSinceDate | date: 'd MMM yyyy' }}</div>
                            </div>

                            <div class="watch-meta-item watch-meta-item-spacer" aria-hidden="true">
                                <div class="watch-meta-label">&nbsp;</div>
                                <div class="watch-meta-value">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-project-summary-table-container [projects]="projects" [selectedProjectIds]="selectedProjectIds"
                [newSince]="newSince" [updatedSince]="highlightSinceDate" [indicateNewProjects]="true" [sort]="sort"
                [usage]="'notifications'" [actions]="summaryActions" (projectSelected)="openProject($event)"
                (selectionChanged)="onSelectionChanged($event)" (restoreRequested)="restoreProject($event)"
                (sortChanged)="onSortChanged($event)">
            </app-project-summary-table-container>
        </mat-drawer-content>
    </mat-drawer-container>
</section>